export default __webpack_public_path__ + "static/media/niftybank-graph.276e33a4.jpg";